import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { ArrowRight, Flag, Cross } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1772943527481-766493f82462?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function Home() {
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then((r) => setFeatured(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="relative min-h-[85vh] flex items-center overflow-hidden">
        <img src={HERO} alt="Race track at night" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/20" />
        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 w-full">
          <div className="max-w-2xl fade-up">
            <p className="text-[#C5A059] text-xs font-bold uppercase tracking-[0.3em] mb-5">Hebrews 12:1 · Run With Endurance</p>
            <h1 className="font-heading font-900 uppercase leading-[0.9] tracking-tight text-5xl sm:text-6xl lg:text-7xl">
              Faith At <span className="text-[#E63946]">Full Throttle</span>
            </h1>
            <p className="text-[#A1A1AA] text-base sm:text-lg mt-6 leading-relaxed max-w-xl">
              Christian racing apparel and stickers for believers who live life in the fast lane.
              Built heavy, worn bold, driven by grace.
            </p>
            <div className="flex flex-wrap gap-4 mt-9">
              <Link to="/shop" data-testid="hero-shop-btn"
                className="bg-[#E63946] hover:bg-[#FF4D5A] text-white font-semibold uppercase tracking-wider text-sm px-8 py-4 flex items-center gap-2 transition-colors">
                Shop Collection <ArrowRight size={16} />
              </Link>
              <Link to="/shop?category=stickers" data-testid="hero-stickers-btn"
                className="border border-white/20 hover:bg-white/10 text-white font-semibold uppercase tracking-wider text-sm px-8 py-4 transition-colors">
                Sticker Packs
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Marquee */}
      <div className="border-y border-white/10 bg-[#050505] overflow-hidden py-4">
        <div className="flex whitespace-nowrap animate-marquee">
          {Array(2).fill(0).map((_, i) => (
            <span key={i} className="font-heading font-900 uppercase text-2xl tracking-tight text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.25)] mx-6">
              Keep Moving Forward · Grace Under Pressure · Race For Him · Victory In Christ ·
            </span>
          ))}
        </div>
      </div>

      {/* Value props */}
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { icon: Cross, title: "Faith Forward", text: "Every design carries a message of hope, grit and grace." },
          { icon: Flag, title: "Track Tested", text: "Heavyweight fabrics and weatherproof vinyl built to endure." },
          { icon: ArrowRight, title: "Fast Shipping", text: "Secure checkout with cards, Apple Pay, Google Pay & PayPal." },
        ].map((v) => (
          <div key={v.title} className="bg-[#121212] border border-white/10 p-8">
            <v.icon className="text-[#E63946] mb-4" size={28} />
            <h3 className="font-heading text-xl font-700 uppercase tracking-tight">{v.title}</h3>
            <p className="text-[#A1A1AA] text-sm mt-2 leading-relaxed">{v.text}</p>
          </div>
        ))}
      </section>

      {/* Featured */}
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-8">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="text-[#C5A059] text-xs font-bold uppercase tracking-[0.3em] mb-2">The Grid</p>
            <h2 className="font-heading text-4xl font-800 uppercase tracking-tight">Featured Gear</h2>
          </div>
          <Link to="/shop" className="text-sm font-semibold uppercase tracking-wider text-[#A1A1AA] hover:text-white transition-colors hidden sm:flex items-center gap-2">
            View All <ArrowRight size={14} />
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {featured.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </section>
    </div>
  );
}
